export const MOBILE_MAX_SIZE = '(min-width: 0px) and (max-width: 720px)';
export const TABLET_MAX_SIZE = '(min-width: 721px) and (max-width: 1279px)';
export const DESKTOP_MAX_SIZE = '(min-width: 1280px)';

export enum ActiveBreakpoint {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
  None = 'none'
}

export enum ScreenOrientation {
  Portrait = 'portrait',
  Landscape = 'landscape'
}

export function breakpointTest(viewportSize: {
  height: number;
  width: number;
}): ActiveBreakpoint {
  let screenOrientation: ScreenOrientation;
  // def screen orientation
  if (viewportSize.width >= viewportSize.height) {
    screenOrientation = ScreenOrientation.Landscape;
  } else {
    screenOrientation = ScreenOrientation.Portrait;
  }

  if (viewportSize.width > 0 && viewportSize.width < 720) {
    return ActiveBreakpoint.Mobile;
  } else if (
    viewportSize.width > 720 &&
    viewportSize.width < 1280 &&
    screenOrientation === ScreenOrientation.Portrait
  ) {
    return ActiveBreakpoint.Tablet;
  } else if (
    viewportSize.width > 720 &&
    viewportSize.width < 1000 &&
    screenOrientation === ScreenOrientation.Landscape
  ) {
    return ActiveBreakpoint.Tablet;
  } else {
    return ActiveBreakpoint.Desktop;
  }
}

/**
 * Preload images.
 * When all images are loaded, then promise is resolved.
 * @param srcs All images URI that you want to preload.
 */
export function preloadImages(...srcs: string[]) {
  return new Promise(resolve => {
    const images = [];
    let count = 0;
    for (const src of srcs) {
      const image = new Image();
      image.onload = () => {
        count++;
        if (images.length === count) {
          resolve('');
        }
      };
      image.src = src;
      images.push(image);
    }
  });
}

export function getImagesPathsByActiveScreen(activeScreen: ActiveBreakpoint) {
  const paths = [
    'assets/images/background/1_',
    'assets/images/background/2_',
    'assets/images/background/3_'
  ];
  let extension = 'desktop.jpg';

  if (activeScreen === ActiveBreakpoint.Mobile) {
    extension = 'mobile.jpg';
  } else if (activeScreen === ActiveBreakpoint.Tablet) {
    extension = 'tablet.jpg';
  }

  for (let i = 0; i < paths.length; i++) {
    paths[i] = paths[i] + '' + extension;
  }

  return paths;
}
